export default __webpack_public_path__ + "static/media/newerabet365.dd56dc93.svg";